import {useEffect, useState} from "react";
import back_arrow from "../../assets/back_arrow.svg"
import forward_arrow from "../../assets/forward_arrow.svg"
import valuer_api from "../../api/valuer";
import {useNavigate} from "react-router-dom";

const ValuerAmendSideBar = (props) => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(true);
    // Fields for updating
    const [valuers, setValuers] = useState([]);
    const [newValuer, setNewValuer] = useState()
    const [statuses, setStatuses] = useState([]);
    const [newStatus, setNewStatus] = useState()

    const requestId = props.requestId

    const requestType = props.requestType
    const valuation = props.valuation;
    const requestTime = props.requestTime
    const request = props.request
    const reportId = props.reportId
    const summaryStatusId = props.summaryStatusId
    const currentStatusId = props.currentStatusId
    const currentValuerId = props.currentValuerId

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        getValuers()
    }, [])

    useEffect(() => {
        if (!summaryStatusId) return
        getStatuses()
    }, [summaryStatusId])

    // Set Defaults for current values
    useEffect(() => {
        if (!currentStatusId) return
        setNewStatus(currentStatusId)
    }, [currentStatusId])
    useEffect(() => {
        if (!currentValuerId) return
        setNewValuer(currentValuerId)
    }, [currentValuerId])

    const getValuers = () => {
        let response = valuer_api.getValuers();
        response.then(
            response => {
                setValuers(response.data.valuers);
            }
        ).catch(err => {
            console.log(err);
        })
    }

    const getStatuses = () => {
        let response = valuer_api.getManualValuerStatuses()
        response.then(
            response => {
                let list = [{"id":6,"name":"New"}];
                list.push(...response.data.statuses);
                // allow a valuer to set the valuer's status if comments have triggered it to be reopened
                if(summaryStatusId === 4) list.push({"id": 9, "name": "Resolved"})
                // allow a valuer to set the valuer's status if comments have triggered it to be reopened
                if(summaryStatusId === 5) list.push({"id": 7, "name": "Closed"})
                setStatuses(list);
            }
        ).catch(err => {
            console.log(err);
        })
    }

    const handleSave = () => {
        if (!reportId) return;
        if (newValuer && parseInt(newValuer) !== currentValuerId) {
            let response = valuer_api.changeValuer(reportId, parseInt(newValuer));
            response.then(
                () => {
                    navigate("/valuer");
                }
            ).catch(err => {
                setErrorTitle("Failed to Update");
                setErrorMessage("Failed to update the valuer of the request, Please try again");
            })
        }
        else if (newStatus && parseInt(newStatus) !== currentStatusId){
            let response = valuer_api.changeStatus(reportId, parseInt(newStatus));
            response.then(
                () => {
                    navigate("/valuer");
                }
            ).catch(err => {
                setErrorTitle("Failed to Update");
                setErrorMessage("Failed to update the status of the request, Please try again");
            })
        }
    }

    return (
        <div className={"valuer-amend-side-bar" + (open ? ' open' : '')}>
            <div className="valuer-amend-side-bar-icon link" onClick={() => setOpen(!open)}>
                <img src={open ? forward_arrow : back_arrow} alt={"arrow"} />
            </div>
            {open && open ?
                <>
                <div className="valuer-amend-side-bar-section">
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">REQUEST TYPE</div>
                        <div className="valuer-sidebar-value">{requestType}</div>
                    </div>
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">VALUE</div>
                        <div className="valuer-sidebar-value">{valuation}</div>
                    </div>
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">REQUEST TIME/DATE</div>
                        <div className="valuer-sidebar-value">{requestTime}</div>
                    </div>
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">REQUESTER</div>
                        <div
                            className="valuer-sidebar-value">{request && request.firstname[0] + "." + request.lastname}</div>
                        <div className="valuer-sidebar-value">{request && request.email}</div>
                        <div className="valuer-sidebar-value">{request && request.orgname}</div>
                    </div>
                </div>
                <div className="valuer-amend-side-bar-section">
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">ASSIGNEE</div>
                        <select onChange={(ev) => setNewValuer(ev.target.value)}
                                disabled={currentStatusId === 7 || currentStatusId === 9} value={newValuer}>
                            {valuers && valuers.map((valuer, idx) => {
                                return (
                                    <option value={valuer.id}>{valuer.firstname} {valuer.lastname}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-label">TICKET STATUS</div>
                        <select onChange={(ev) => setNewStatus(ev.target.value)}
                                disabled={currentStatusId === 7 || currentStatusId === 9} value={newStatus}>
                            {statuses && statuses.map((status, idx) => {
                                return (
                                    <option value={status.id} disabled={status.id === 6}>{status.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className={(newValuer && parseInt(newValuer) !== currentValuerId) ||
                    (newStatus && parseInt(newStatus) !== currentStatusId)
                        ? "valuer-amend-save-button link sidebar"
                        : "valuer-amend-save-button disabled sidebar"}
                         onClick={() => handleSave()}>
                        Save
                    </div>
                </div>
                <div className="valuer-amend-side-bar-section last">
                    <div className="valuer-amend-sidebar-property">
                        <div className="valuer-sidebar-changelog-button link" onClick={() => navigate(`/valuer/review/${requestId}`)}>See full change log</div>
                    </div>
                </div>
            </>
            : null
        }
        </div>
    )
}

export default ValuerAmendSideBar;